// extracted by mini-css-extract-plugin
export default {"serviceBlockContainer":"Servcies_serviceBlockContainer__x365n","desc":"Servcies_desc__Pmjs0","bgcolor":"Servcies_bgcolor__OoFxP"};